<div *ngIf="isSimilarPhoto" class="similar-photo-text">
  <div><nb-icon icon="info-outline"></nb-icon> <span [innerText]="similarPhotoText"></span></div>
</div>

<div class="name-table__icons" [class.name-table__icons--inline]="inline" *ngIf="product?.markers">
  <ng-container *ngFor="let marker of product.markers">
    <div class="item" *ngIf="11 !== marker.id">
      <span class="{{marker.icon}}">{{marker.header}}</span>
    </div>
  </ng-container>
</div>
